export const capitalizeFirstLetters = (str) => {
	if (!str || str === "NULL") return str;

	return str
		.toLowerCase()
		.split(" ")
		.map((word) => {
			if (word.toLowerCase() === "in") {
				return "in";
			} else if (word.length <= 3 && !["day", "and"].includes(word)) {
				return word.toUpperCase();
			} else {
				return word.charAt(0).toUpperCase() + word.slice(1);
			}
		})
		.join(" ");
};
